import { Component, OnDestroy, OnInit } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { ProjectsService } from '../../../services/projects.service';
import { TranslateService } from '@ngx-translate/core';
import { RouterUrls } from '../../../shared/router-urls';
import * as Projects from '../../../shared/projects.model';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../shared/user.model';
import { Constants } from '../../../app.constants';
import { Router } from '@angular/router';
import { VolunteeringService } from 'src/app/services/volunteering.service';


@Component({
  selector: 'app-project-volunteering',
  templateUrl: './project-volunteering.component.html',
  styleUrls: ['./project-volunteering.component.scss']
})
export class ProjectVolunteeringComponent implements OnInit, OnDestroy {
  public Constants = Constants;

  projectVolunteeringOffers: Projects.IndividualMission[];
  userAppliedOffers: number[] = [];
  paginationLimit = 5;
  RouterUrls = RouterUrls;
  user: User;
  screenWidth: number;
  private subscriptions = new Subscription();


  constructor(private projectsService: ProjectsService,
              private volunteeringService: VolunteeringService,
              private translate: TranslateService,
              private router: Router,
              private authService: AuthService) {}

    ngOnInit(): void {
      this.screenWidth = window.innerWidth;
this.subscriptions.add(
      this.projectsService.fullProjectInfo
        .pipe(
          switchMap(projectInfo => this.volunteeringService.getProjectVolunteering(projectInfo?.organization_id)),
        )
        .subscribe(projectVolunteeringOffers => this.projectVolunteeringOffers = projectVolunteeringOffers)
    );
      this.subscriptions.add(this.authService.currentUser.subscribe(
          user => {
            this.user = user;
            this.getUserAppliedOffers(this.user.email);
          }
        ));

      this.subscriptions.add(
      this.volunteeringService.userMissionsUpdated$.subscribe(() => {
        this.getUserAppliedOffers(this.user.email);
      }));
    }

  get currentLang() {
    return this.translate.currentLang;
  }

  private getUserAppliedOffers(userEmail: string) {
    this.volunteeringService.getUserAppliedProjects(userEmail).subscribe((data) => {
      this.userAppliedOffers = data?.offers;
      if (this.userAppliedOffers && this.userAppliedOffers.length > 0) {
        this.projectVolunteeringOffers.forEach((project: Projects.IndividualMission) => {
          project.hasApplied = this.hasApplied(project.id);
        });
      }
    });
  }

  private hasApplied(projectId: number): boolean {
    return this.userAppliedOffers.includes(projectId);
  }

  navigateToAllOffers(){
    this.router.navigate([this.currentLang, RouterUrls.MainVolunteeringPage]);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
